import React, { useState } from 'react';
import { WizardStepper } from 'components/organisms/Wizard/WizardStepper';
import { ApplyOnlineWizardStep } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/ApplyOnlineWizardStep';
import { WizardFooter } from 'components/organisms/Wizard/WizardFooter';
import { Box } from '@mui/material';
import ApplicationStore from 'state/ApplicationStore';
import { useApplyWizard } from './hooks';

const steps = [
  'Personal Data',
  'Health and Medical Declaration',
  'Shotgun Details',
  'Referee Details',
  'Offences',
  'Attachments',
  'Declaration',
];

const ApplyOnlineWizardPage = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [submitCaller, setSubmitCaller] = useState<null | number>(null);

  const { saveApplication } = useApplyWizard();

  const nextHandler = () => {
    ApplicationStore.setSubmitFormEvent();
    setSubmitCaller(Math.floor(Math.random() * 10000));
  };

  const setNextStep = (step?: number) => {
    if (activeStep === steps.length) return;
    setActiveStep(step || ((prevActiveStep) => prevActiveStep + 1));
    window.scrollTo(0, 0);
  };

  (window as any).fcFunction = () => {
    (async () => {
      await saveApplication();
    })();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
      <WizardStepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} />
      <ApplyOnlineWizardStep
        activeStep={activeStep}
        submitCaller={submitCaller}
        setNextStep={setNextStep}
      />
      <WizardFooter
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        nextHandler={nextHandler}
        steps={steps}
      />
    </Box>
  );
};

export { ApplyOnlineWizardPage };
